"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _GhostIconButton = _interopRequireDefault(require("../Buttons/GhostIconButton"));
var _helpers = require("../helpers");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var ModalCloseButton = (0, _styledComponents["default"])(_GhostIconButton["default"]).attrs(function (props) {
  return {
    name: "Clearclose",
    p: props.p || "s"
  };
}).withConfig({
  displayName: "ModalCloseButton",
  componentId: "sc-dv6x1h-0"
})(["position:absolute;top:", ";right:", ";z-index:", ";", ""], function (props) {
  return (0, _helpers.getSpace)(props, "top", "none");
}, function (props) {
  return (0, _helpers.getSpace)(props, "right", "none");
}, function (props) {
  return props.theme.zIndex.modalClose;
}, function (props) {
  return props.noPositioning && (0, _styledComponents.css)(["position:relative;top:auto;right:auto;z-index:auto;"]);
});
var _default = ModalCloseButton;
exports["default"] = _default;